const botActionTypes = {
  SET_BOT_UPDATE_DATA: 'SET_BOT_UPDATE_DATA',
  REMOVE_BOT_UPDATE_DATA: 'REMOVE_BOT_UPDATE_DATA',
  REMOVE_BOT_DELETE_DATA: 'REMOVE_BOT_DELETE_DATA',
  BOT_FILTER_REQUEST: 'BOT_FILTER_REQUEST',
  BOT_FILTER_SUCCESS: 'BOT_FILTER_SUCCESS',
  BOT_FILTER_FAILURE: 'BOT_FILTER_FAILURE',
  BOT_START_FETCH: 'BOT_START_FETCH',
  BOT_SET_ERROR: 'BOT_SET_ERROR',
  BOT_REMOVE_ERROR: 'BOT_REMOVE_ERROR',
  FETCH_BOTS_REQUEST: 'FETCH_BOTS_REQUEST',
  FETCH_BOTS_SUCCESS: 'FETCH_BOTS_SUCCESS',
  FETCH_BOTS_FAILURE: 'FETCH_BOTS_FAILURE',
  REMOVE_BOTS: 'REMOVE_BOTS',
  REMOVE_BOTS_POPUP: 'REMOVE_BOTS_POPUP',
  CREATE_BOT_REQUEST: 'CREATE_BOT_REQUEST',
  CREATE_BOT_SUCCESS: 'CREATE_BOT_SUCCESS',
  CREATE_BOT_FAILURE: 'CREATE_BOT_FAILURE',
  FETCH_BOT_DETAILS_REQUEST: 'FETCH_BOT_DETAILS_REQUEST',
  FETCH_BOT_DETAILS_SUCCESS: 'FETCH_BOT_DETAILS_SUCCESS',
  FETCH_BOT_DETAILS_FAILURE: 'FETCH_BOT_DETAILS_FAILURE',
  REMOVE_BOT_DETAILS: 'REMOVE_BOT_DETAILS',
  REMOVE_BOT_DETAILS_POPUP: 'REMOVE_BOT_DETAILS_POPUP',
  DELETE_BOT_REQUEST: 'DELETE_BOT_REQUEST',
  DELETE_BOT_SUCCESS: 'DELETE_BOT_SUCCESS',
  DELETE_BOT_FAILURE: 'DELETE_BOT_FAILURE',
  UPDATE_BOT_REQUEST: 'UPDATE_BOT_REQUEST',
  UPDATE_BOT_SUCCESS: 'UPDATE_BOT_SUCCESS',
  UPDATE_BOT_FAILURE: 'UPDATE_BOT_FAILURE',

  FETCH_BOT_FILE_DOWNLOAD_REQUEST: 'FETCH_BOT_FILE_DOWNLOAD_REQUEST',
  FETCH_BOT_FILE_DOWNLOAD_FAILURE: 'FETCH_BOT_FILE_DOWNLOAD_FAILURE',
  FETCH_BOT_FILE_DOWNLOAD_SUCCESS: 'FETCH_BOT_FILE_DOWNLOAD_SUCCESS',
  FETCH_BOT_NAMES_REQUEST: 'FETCH_BOT_NAMES_REQUEST',
  FETCH_BOT_NAMES_SUCCESS: 'FETCH_BOT_NAMES_SUCCESS',
  FETCH_BOT_NAMES_FAILURE: 'FETCH_BOT_NAMES_FAILURE',
  GET_BOT_BACKBTN_SUCCESS: 'GET_BOT_BACKBTN_SUCCESS',
  GET_BOT_BACKBTN_FAILURE: 'GET_BOT_BACKBTN_FAILURE',
  UPDATE_BOT_PAGE: 'UPDATE_BOT_PAGE',
};

export default botActionTypes;
